import { KYDAdminEventDetailSectionPermissions } from "@common/interfaces/KYDEvent";

const ShowIfHasPermission = ({
  permissions = [],
  checkFor,
  children,
}: {
  permissions: KYDAdminEventDetailSectionPermissions;
  checkFor: string;
  children: JSX.Element;
}) => {
  //@ts-ignore
  if (permissions.includes(checkFor)) {
    return children;
  }

  return null;
};

export default ShowIfHasPermission;
